import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vilken paragraf styr kunskapsprovet?";
const SHORT_ANSWER = "8 kap. 12 § alkohollagen samt Folkhälsomyndighetens föreskrifter FoHMFS 2014:7.";

export const Route = createFileRoute("/fraga/vilken-paragraf-styr-kunskapsprovet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vilken paragraf styr kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Lagparagrafen ger den grundläggande skyldigheten. Föreskrifterna anger antalet frågor, områden och godkäntgränser. Båda är levande dokument – senaste version finns hos Folkhälsomyndigheten."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[{"label": "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", "href": "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/"}]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – det rättsliga ramverket" }}
      related={[{"to": "/fraga/far-funktionshindrade-extra-tid", "label": "Får funktionshindrade extra tid på kunskapsprovet?"}, {"to": "/fraga/ar-provet-svart", "label": "Är kunskapsprovet svårt?"}, {"to": "/fraga/hur-rattas-provet", "label": "Hur rättas kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vilken paragraf styr kunskapsprovet?" },
      { name: "description", content: "8 kap. 12 § alkohollagen samt Folkhälsomyndighetens föreskrifter FoHMFS 2014:7." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vilken-paragraf-styr-kunskapsprovet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vilken-paragraf-styr-kunskapsprovet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vilken-paragraf-styr-kunskapsprovet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vilken paragraf styr kunskapsprovet", url: "https://alkoholprovet.se/fraga/vilken-paragraf-styr-kunskapsprovet" },
      ]),
    ],
  }),
});
